<template>
  <v-container id="insights">
    <!-- <v-card> -->
    <!-- <v-card-title class="text-center text-h6 text-primary">
      Beneficios de Truster Cloud
    </v-card-title> -->
    <v-card-title class="text-h4 pa-3 text-center font-weight-bold">
      Por qué Truster Cloud es la opción correcta para tu negocio
    </v-card-title>
    <v-row ref="container" class="py-6">
      <v-col
        cols="12"
        sm="6"
        xl="3"
        v-for="(insight, idx) in insights"
        :key="idx"
        class="d-flex align-start justify-center h-ingerit"
      >
        <v-card
          rounded="xl"
          class="pa-8 text-center d-flex flex-column align-center justify-center h-100"
          color="ternary"
          elevation="4"
        >
          <v-icon
            :icon="insight.icon"
            size="80"
            class="mr-2 pa-1 border-thin rounded-circle bg-primary text-white"
          />
          <v-card-title class="pt-0 text-h5 text-secondary">
            {{ insight.title }}
          </v-card-title>
          <v-card-text class="text-h6" style="line-height: 1.5">
            {{ insight.description }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-card> -->
  </v-container>
</template>

<script setup lang="js">
import { useDisplay } from "vuetify";
// import { ref, onMounted, onUnmounted } from 'vue'
const { smAndDown } = useDisplay();
// import { gsap } from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

// gsap.registerPlugin(ScrollTrigger)

// const container = ref(null)
// let gsapContext = null

// onMounted(() => {
// 	// Esperamos a que Vuetify y el DOM estén listos
// 	nextTick(() => {
// 		// El contexto se aplica al contenedor principal (<v-row>)
// 		gsapContext = gsap.context(() => {
// 			// Buscamos todas las tarjetas que necesitan ser animadas
// 			const cards = gsap.utils.toArray('.card-anim')

// 			// 3. NUEVA LÓGICA DE ANIMACIÓN
// 			// Creamos una animación para CADA tarjeta, en lugar de una sola timeline
// 			cards.forEach((card) => {
// 				gsap.fromTo(
// 					card,
// 					{
// 						opacity: 0,
// 						x: 100 // Empieza desde la derecha
// 					},
// 					{
// 						opacity: 1,
// 						x: 0,
// 						ease: 'power2.out',
// 						// El ScrollTrigger se configura para cada tarjeta individualmente
// 						scrollTrigger: {
// 							trigger: card, // El trigger es la propia tarjeta
// 							start: 'top 80%', // La animación empieza cuando el 80% de la tarjeta es visible
// 							end: 'bottom 20%', // (Opcional) puedes definir un final
// 							toggleActions: 'play none none reverse' // Anima al entrar, revierte al salir
// 							// markers: true, // Descomenta para depurar una tarjeta específica
// 						}
// 					}
// 				)
// 			})
// 		}, container.value)
// 	})
// })

// onUnmounted(() => {
// 	if (gsapContext) {
// 		gsapContext.revert()
// 	}
// })

// Tus datos de 'insights' permanecen igual
const insights = [
  {
    title: "Escalabilidad Inteligente",
    description:
      "Crece sin límites. Nuestra nube se adapta a tus necesidades en tiempo real, pagando solo por los recursos que realmente utilizas.",
    icon: "$mdiTrendingUp", // Icono de crecimiento/escalabilidad
  },
  {
    title: "Aliados, no solo Proveedores",
    description:
      "Accede a un equipo de ingenieros expertos siempre dispuestos a ayudarte. Tu éxito es el motor de nuestras soluciones.",
    icon: "$mdiHandshake", // Icono de alianza/colaboración
  },
  {
    title: "Rendimiento Superior Garantizado",
    description:
      "Experimenta velocidad y un 99.9% de uptime en nuestra infraestructura de élite. Impulsamos tu negocio para que nunca se detenga.",
    icon: "$mdiSpeedometer", // Icono de rendimiento/velocidad
  },
  {
    title: "Fortaleza Digital Inquebrantable",
    description:
      "Protegemos tus datos con encriptación avanzada y vigilancia proactiva 24/7. Tu tranquilidad es nuestro código y nuestra máxima prioridad.",
    icon: "$mdiShieldLock", // Icono de seguridad/protección
  },
];
</script>

<style lang="scss" scoped>
/* 4. ESTILOS PARA LA COLUMNA PEGAJOSA (STICKY) */

.sticky-column {
  position: sticky;
  /* 'top' define a qué distancia del borde superior se "pegará" la columna.
     Ajusta este valor según la altura de tu barra de navegación (AppBar) */
  top: 100px;
  flex-direction: column;
  align-self: flex-start; /* MUY IMPORTANTE para que sticky funcione en un contenedor flex (v-row) */
}

.sticky-content {
  display: flex;
  flex-direction: column; /* Permite apilar título y subtítulo */
  justify-content: center; /* Centra verticalmente */
  align-items: flex-start; /* Alinea a la izquierda para textos largos */
  height: calc(100vh - 120px);
  padding: 0 16px; /* Espaciado lateral para textos largos */
  gap: 16px; /* Espacio entre título y subtítulo */
  word-break: break-word; /* Permite saltos de línea en textos largos */
}

/* Estado inicial de las tarjetas para la animación (opcional, GSAP lo maneja con fromTo) */
.card-anim {
  opacity: 1;
}
</style>
